import React from 'react';
import { Box } from '@mui/material';
import Header from '../common/Header';
import Footer from '../common/Footer';

export default function AppLayout({ children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box component="main" sx={{ flex: 1, pt: '64px', backgroundColor: '#f6f8fa' }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
}
